/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlMonitType = {
    Active: 'active',
    Passive: 'passive'
} as const;
export type ControlMonitType = typeof ControlMonitType[keyof typeof ControlMonitType];


export function ControlMonitTypeFromJSON(json: any): ControlMonitType {
    return ControlMonitTypeFromJSONTyped(json, false);
}

export function ControlMonitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlMonitType {
    return json as ControlMonitType;
}

export function ControlMonitTypeToJSON(value?: ControlMonitType | null): any {
    return value as any;
}

